import React, { useEffect } from 'react';
import Helmet from 'react-helmet';

const MetaTagHolder = ({ info }) => {
  useEffect(() => {
    console.log(info);
  }, [info]);
  return (
    <Helmet>
      ] <title> {(info && `${info.ratio}% match!`) || 'Doccen'} </title>
      <meta
        name="description"
        content="Medical edtech social network platform"
      />
      <meta property="og:type" content="article" />
      <meta
        name="og:title"
        property="og:title"
        content={
          (info && `${info.ratio} điểm: phù hợp với ngành Y!`) ||
          'BẠN có phù hợp với ngành Y?'
        }
      />
      <meta
        property="og:image"
        content="https://ktkdqt.ftu.edu.vn/wp-content/uploads/2021/06/ftu-e1625055351669.jpg"
      />
      <meta
        name="og:description"
        property="og:description"
        content={
          (info &&
            `${info.username} đã phù hợp đến ${info.ratio} điểm, còn bạn?`) ||
          'Khám phá bằng bài trắc nghiệm nhanh'
        }
      />
      <meta property="og:url" content="doccen.vn" />
      <meta property="og:locale" content="vi" />
      <link rel="icon" type="image/png" href="public/favicon.ico" />
      <link rel="apple-touch-icon" href="public/favicon.ico" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    </Helmet>
  );
};

export default MetaTagHolder;
